import { CostReviewBaseAttributes } from "./CostReviewBaseAttributes";
import { CostReviewFireEnUsWiringResponsibilities } from "./CostReviewFireEnUsWiringResponsibilities";
import { CostReviewSecurityEnUsAccessControlSystems } from "./CostReviewSecurityEnUsAccessControlSystems";
import { CostReviewSecurityEnUsCctvSystems } from "./CostReviewSecurityEnUsCctvSystems";
import { CostReviewSecurityEnUsExecutionSchedule } from "./CostReviewSecurityEnUsExecutionSchedule";
import { CostReviewSecurityEnUsGeneralConditions } from "./CostReviewSecurityEnUsGeneralConditions";
import { CostReviewSecurityEnUsIntercomSystem } from "./CostReviewSecurityEnUsIntercomSystem";
import { CostReviewSecurityEnUsIntrusionSystem } from "./CostReviewSecurityEnUsIntrusionSystem";
import { CostReviewSecurityEnUsManagementStation } from "./CostReviewSecurityEnUsManagementStation";
import { CostReviewSecurityEnUsNetwork } from "./CostReviewSecurityEnUsNetwork";
import { CostReviewSecurityEnUsRetrofitConsiderations } from "./CostReviewSecurityEnUsRetrofitConsiderations";

export class CostReviewSecurityEnUsAttributes extends CostReviewBaseAttributes {
  costReviewSecurityEnUsGeneralConditions!: CostReviewSecurityEnUsGeneralConditions;
  costReviewSecurityEnUsExecutionSchedule!: CostReviewSecurityEnUsExecutionSchedule;
  costReviewSecurityEnUsNetwork!: CostReviewSecurityEnUsNetwork;
  costReviewSecurityEnUsRetrofitConsiderations!: CostReviewSecurityEnUsRetrofitConsiderations;
  costReviewSecurityEnUsAccessControlSystems!: CostReviewSecurityEnUsAccessControlSystems;
  costReviewSecurityEnUsCctvSystems!: CostReviewSecurityEnUsCctvSystems;
  costReviewSecurityEnUsIntercomSystem!: CostReviewSecurityEnUsIntercomSystem;
  costReviewSecurityEnUsIntrusionSystem!: CostReviewSecurityEnUsIntrusionSystem;
  costReviewFireEnUsWiringResponsibilities!: CostReviewFireEnUsWiringResponsibilities;
  costReviewSecurityEnUsManagementStation!: CostReviewSecurityEnUsManagementStation;
  isLaborTDCPercentExceeds!: boolean;
  reasonForLaborVariance!: string;
}
